'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EnterpriseSubHeader = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(EnterpriseSubHeader, _Component);

  function EnterpriseSubHeader() {
    (0, _classCallCheck3.default)(this, EnterpriseSubHeader);
    return (0, _possibleConstructorReturn3.default)(this, (EnterpriseSubHeader.__proto__ || (0, _getPrototypeOf2.default)(EnterpriseSubHeader)).apply(this, arguments));
  }

  (0, _createClass3.default)(EnterpriseSubHeader, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          className = _props.className;

      var styles = require('./EnterpriseSubHeader.scss');

      return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)(className, styles.root) },
        children
      );
    }
  }]);
  return EnterpriseSubHeader;
}(_react.Component), _class.propTypes = {
  children: _react.PropTypes.node,
  className: _react.PropTypes.string
}, _temp);
exports.default = EnterpriseSubHeader;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/enterprise/EnterpriseSubHeader/EnterpriseSubHeader.jsx
// module id = 1608
// module chunks = 0